/* eslint-disable react/no-danger */
/* eslint-disable no-plusplus */
// @flow

import React, { useState, useEffect } from 'react';
import { useTransition } from 'react-spring';
import { IconCloseO } from 'icons';
import { Container, Message, Button, Content, Life } from './styles';

const defaultOptions = {
  timeout: 4000,
  config: {
    tension: 125,
    friction: 20,
    precision: 0.1
  }
};

let id = 0;

export default function Toast({ notify }: any) {
  const [refMap] = useState(() => new WeakMap());
  const [cancelMap] = useState(() => new WeakMap());
  const [items, setItems] = useState([]);

  const transitions = useTransition(items, item => item.key, {
    from: {
      opacity: 0,
      height: 0,
      life: '100%'
    },
    enter: item => async next => {
      await next({
        opacity: 1,
        height: (refMap.get(item) || {}).offsetHeight
      });
    },
    leave: item => async (next, cancel) => {
      cancelMap.set(item, cancel);
      await next({ life: '0%' });
      await next({ opacity: 0 });
      await next({ height: 0 });
    },
    onRest: item => {
      setItems(state => state.filter(i => i.key !== item.key));
    },
    config: (item, state) => {
      const options = { ...defaultOptions, ...item.options };
      return state === 'leave' ? [{ duration: options.timeout }, options.config, options.config] : options.config;
    }
  });

  useEffect(() => {
    notify((msg, options) => setItems(state => [...state, { key: id++, msg, options }]));
  }, []);

  const handleClose = item => () => {
    if (cancelMap.has(item)) {
      const itemMap = cancelMap.get(item);
      if (itemMap) itemMap(item);
    }
  };

  return (
    <Container>
      {transitions.map(({ key, item, props: { life, ...style } }) => (
        <Message key={key} style={style}>
          <Content ref={ref => ref && refMap.set(item, ref)} error={item.options.error}>
            <Life style={{ right: life }} />
            <p dangerouslySetInnerHTML={{ __html: item.msg }} />
            <Button type="button" onClick={handleClose(item)}>
              <IconCloseO />
            </Button>
          </Content>
        </Message>
      ))}
    </Container>
  );
}
